import { OrderTable } from '@services/product/order/order.types';
import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { openPrintWindow } from '@utils/printUtils';
import { generateOrdersPrintHTML } from './ListPagePrint';
import { useGetETicketTypesMutation } from '@services/product/eTicketType/e-ticket-type.endpoints';
import { ETicketType } from '@services/product/eTicketType/e-ticket-type.types';

export const useListPageVM = () => {
    const [totalOrders, setTotalOrders] = useState<number>(0);
    const [eticketTypes, setEticketTypes] = useState<ETicketType[]>([]);
    const columnHelper = createColumnHelper<OrderTable>();
    const navigate = useNavigate();
    const [getETicketTypes] = useGetETicketTypesMutation();

    useEffect(() => {
        getETicketTypes(undefined).unwrap().then((res) => {
            setEticketTypes(res.data);
        });
    }, []);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalOrders(metadata.total);
        }
    };

    const handlePrint = async (orders: OrderTable[]) => {
        if (!orders || !orders?.length) {
            console.error("Aucune commande n'est sélectionnée");
            return;
        }

        try {
            const printHtml = generateOrdersPrintHTML(orders);
            await openPrintWindow(printHtml, {
                title: `Commandes sélectionnées - ${orders.length} commande(s)`,
                width: 800,
                height: 600
            });
        } catch (error) {
            console.error("Erreur lors de l'impression:", error);
        }
    };

    return {
        totalOrders,
        eticketTypes,
        columnHelper,
        navigate,
        handleMetadata,
        handlePrint
    };
};
